import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
//import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import 'rxjs/add/operator/map';
import { AlertService } from '../alert.service';
import { User } from '../User';
import { Router } from '@angular/router';
//import { months } from 'moment';
import { ModalDirective } from 'angular-bootstrap-md';
import { Meta, Title } from "@angular/platform-browser";
import { WOW } from 'wowjs/dist/wow.min';



@Component({
    selector: 'app-model',
    templateUrl: './model.component.html',
    styleUrls: ['./model.component.scss']
})
 
export class ModelComponent implements OnInit {
    @ViewChild('join') join: ModalDirective;
    @ViewChild('alredyJoin') alredyJoin: ModalDirective;
    @ViewChild('JoinBeforeLogin') JoinBeforeLogin: ModalDirective;
    userLoggedIn = false;
    dataToInit: Array<any> = [];
    monthSelected : number = 1;
    debugData: Boolean = true; // to show and hide the console log messages
    selectedMonthsVal : number = 0; // to show the selected value in ui changes
    joinMsg: string = ""; // to display the join waitlist message
    alreadyJoinMsg: string=""; //to display already joined message
    JoinBeforeLoginMsg: string =""; //to display message before login
    browser: Boolean;

    deviceInfo = null;

 ngAfterViewInit(){

        new WOW().init();
      }
    private user: User = new User();
    constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
        private router: Router, private httpClient: HttpClient,
        private alertService: AlertService,meta: Meta, title: Title, private deviceService: DeviceDetectorService) {
        this.initCustData();
        this.initModelData(1);
        this.epicFunction();

        

    meta.addTags([
      { name: 'author',   content: 'on-track.in'},
      { name: 'keywords', content: 'bike rental company'},
      { name: 'description', content: 'Monthly Bike Rental Redefining day-to-day travel!' }
    ]);
    }

    epicFunction() {
        console.log('hello `Home` component');
        this.deviceInfo = this.deviceService.getDeviceInfo();
        const isMobile = this.deviceService.isMobile();
        const isTablet = this.deviceService.isTablet();
        const isDesktopDevice = this.deviceService.isDesktop();
        console.log(this.deviceInfo);
        console.log(isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
        console.log(isTablet);  // returns if the device us a tablet (iPad etc)
        console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.
        console.log(this.deviceInfo.browser);
        if(this.deviceInfo.browser == 'Safari'){
        this.browser = true; }
        else{
        this.browser = false;    
        }
        console.log(this.browser);
      }

    jsonDataArray(months) {
        let monthlyDiscountPercent = [3.64, 4.73, 5.82, 6.91, 8.00, 9.09, 10.18, 11.27, 12.36, 13.45, 14.55];
        let temp = this.dataToInit;
        this.monthSelected = months;
        temp.forEach((value) => {
            if (months == 1) {
                this.dataToInit = temp;
            } else if (months == 3) {
                let tempVals = 0;
                for (let i = 0; i < 2; i++) {
                    tempVals += Number(((value.price * monthlyDiscountPercent[i]) / 100).toFixed(2));
                    console.log(tempVals);
                }
                value.price = value.price - Number((tempVals / 3).toFixed(0));
            } else if (months == 6) {
                let tempVals = 0;
                for (let i = 0; i < 5; i++) {
                    tempVals += Number(((value.price * monthlyDiscountPercent[i]) / 100).toFixed(2));
                }
                value.price = value.price - Number((tempVals / 6).toFixed(0));
            } else if (months == 12) {
                let tempVals = 0;
                for (let i = 0; i < 11; i++) {
                    tempVals += Number(((value.price * monthlyDiscountPercent[i]) / 100).toFixed(2));
                }
                value.price = value.price - Number((tempVals / 12).toFixed(0));
            }
        });
        this.dataToInit = temp;
    }

    initModelData(months: number) {
        this.selectedMonthsVal = months;
        if(this.debugData == true){
            //console.log("Months Selected");
            //console.log(this.selectedMonthsVal);
        }
        
        this.apiService.get('getModels')
            .subscribe(dataa => {
                this.dataToInit = dataa;
                //console.log(this.dataToInit);
                if (this.dataToInit.length != 0){
                    this.arrangModel();
                    this.jsonDataArray(months);
                }else{
                    this.error("Error loading page. Please refresh.");
                }
            });
    }


    dataToInit2: Array<any> = [];
    arrangModel(){
        this.dataToInit2 = [];
        for (let i = 0; i < this.dataToInit.length ; i++){
            if ((this.dataToInit[i].available > 0) && (this.dataToInit[i].show >0)){
                this.dataToInit2.push(this.dataToInit[i]);
            }
        }
        for (let i = 0; i < this.dataToInit.length; i++) {
            if (!((this.dataToInit[i].available > 0) && (this.dataToInit[i].show > 0))) {
                this.dataToInit2.push(this.dataToInit[i]);
            }
        }
        //console.log(this.dataToInit2);
        //console.log(this.dataToInit);
        this.dataToInit = this.dataToInit2;
        //d.available > 0 && d.show > 0;
    }

    initCustData() {
        if (this.apiService.checkUserLoggedIn() == true) {
            let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
            this.httpClient.get(urrr)
                .subscribe(
                    data => this.intilizeComponent(data),
                    error => this.showError(error)
                );
        } else {
           // console.log("User Not Logged In. Please login!")
            
        }
    }

    intilizeComponent(data) {
        this.user = data;
    }

    goNextPage(event,name, id) {
        //console.log(id);
     
        var paramName = "Rent_"+name;
        var dname=decodeURIComponent(paramName);
        dname.replace(/\+/g,'%20');
        console.log(dname);
        var paramid = id;
        var monthsId = this.monthSelected;
        this.router.navigate(['model',dname, paramid, monthsId]);
        //this.router.navigate(['model',decodeURIComponent(dname), paramid, monthsId]);
        console.log(['model',dname, paramid, monthsId])
        
    }


    showError(msg) {
        this.warn("Some Error Occured please try again");
    }

    ngOnInit() {
        //console.log(decodeURIComponent(this.router.url));
    }

    success(message: string) {
        this.alertService.success(message);
    }

    error(message: string) {
        this.alertService.error(message);
    }

    info(message: string) {
        this.alertService.info(message);
    }

    warn(message: string) {
        this.alertService.warn(message);
    }

    clear() {
        this.alertService.clear();
    }

    joinWaitlist(event, idModel, nameModel) {
        if (this.apiService.checkUserLoggedIn() == false) {
           // console.log("redirect to the login page if not logged in");
            //this.warn("Please login/signup to join waitlist");
            this.JoinBeforeLoginMsg="Please login/signup to join waitlist";
            this.JoinBeforeLogin.show();
        } else {
            if (this.user.mobile == null || this.user.email == null) {
                this.warn("please complete your profile");
            } else {
                let joinWaitListObjData = {
                    "name": this.user.fName,
                    "mobile": this.user.mobile,
                    "model": nameModel,
                    "emailId": this.user.email,
                    "modelId": idModel,
                    "customerId": this.user.id
                }
                //Posting the data for the joining waitlist
                this.httpClient.post(this.apiService.joinWaitlistUrl, joinWaitListObjData).subscribe((detail: any) => {
                    if (detail.status == true) {
                       // this.success("Waitlist Joined Sucessfully");
                        this.joinMsg="Waitlist Joined Sucessfully";
                        this.join.show();
                    } else {
                        //this.info("Waitlist Already Joined");
                        this.alreadyJoinMsg="Waitlist Already Joined";
                        this.alredyJoin.show();
                    }
                });
            }
        }
    }
}

 


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/model/model.component.ts